import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const Wrapper = styled.div`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.15px;
  color: #152946;
  margin-bottom: 24px;
`;

export const InfoBox = styled.div`
  background: ${props => props.theme.colors.branding.boxesModals};
  box-shadow: 0 2px 10px rgba(147, 150, 174, 0.25);
  border-radius: 16px;

  width: 100%;
  max-width: 340px;
  min-height: 200px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 24px 10px;
  margin-bottom: 48px;
`;

export const VerificationSteps = styled.div`
  flex-direction: column;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
`;

export const Text = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontPrimary : '#152946'};
  max-width: 312px;
  margin: 0 auto 24px;

  @media (min-width: ${DEVICE.mobileXL}) {
    margin: 0 auto 48px;
    font-size: 16px;
    max-width: 550px;
  }
`;
